import { render, staticRenderFns } from "./BodyCompositionCard.vue?vue&type=template&id=47e5d66e&scoped=true"
import script from "./BodyCompositionCard.vue?vue&type=script&lang=js"
export * from "./BodyCompositionCard.vue?vue&type=script&lang=js"
import style0 from "./BodyCompositionCard.vue?vue&type=style&index=0&id=47e5d66e&prod&scoped=true&lang=css"
import style1 from "./BodyCompositionCard.vue?vue&type=style&index=1&id=47e5d66e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e5d66e",
  null
  
)

export default component.exports